import React from "react";
import './App.css';
import Navigation from './components/Navigation/Navigation';
import Introduction from './components/Introduction/Introduction';
import About from './components/About/About';
import Courses from "./components/Courses/Courses";
import CollabLinks from "./components/CollabLinks/CollabLinks";
// import Codiem from "./components/Codiem/Codiem";
import SocialMedia from "./components/SocialMedia/SocialMedia";
// import Consultancy from "./components/Consultancy/Consultancy";
import Footer from "./components/Footer/Footer";

const socialsMedia = [
  { icono: 'github', url: 'https://github.com/r2d2-coder-git' },
  { icono: 'instagram', url: 'https://www.instagram.com/r2d2.coder/' },
  { icono: 'youtube', url: 'https://www.youtube.com/channel/UCFu275cNexSxEV09YpnFqrw' },
];

function App() {
  return (
    <div className="app">
      <Navigation />
      <main className="main-content">
        <Introduction title="Arturo Lorenzo" description="Ingeniero Informático & Creador de Contenido" />
        <About />
        <Courses />
        <CollabLinks />
        {/* <Codiem /> */}
        <SocialMedia socialsMedia={socialsMedia} />
        {/* <Consultancy /> */}
      </main>
      <Footer />
    </div>
  );
}

export default App;
